//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { InternalButtonSpinner } from '@campaigns/components/shared/InternalButtonSpinner';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import { BodyText } from '@components/atoms/text/Text';
import { Modal } from '@components/molecules/modal/Modal';

interface ProductSplitUpdateModalProps {
  isOpen: boolean;
  isReviewingSplit: boolean;
  onClose: () => void;
  onReviewSplit: () => void;
}

export const ProductSplitUpdateModal = ({
  isOpen,
  isReviewingSplit,
  onClose,
  onReviewSplit,
}: ProductSplitUpdateModalProps) => (
  <Modal
    closeModal={isReviewingSplit ? undefined : onClose}
    contents={
      <>
        <BodyText>
          You've changed the quantity for one or more products. Your custom
          split hasn't changed, so it no longer adds up to the new quantity.
          You'll need to update it before you can submit your request.
        </BodyText>
      </>
    }
    isModalOpen={isOpen}
    primaryButtonInfo={{
      buttonContent: isReviewingSplit ? (
        <ReviewSplitButtonContent>
          Review split
          <InternalButtonSpinner>
            <CenteredSpinner />
          </InternalButtonSpinner>
        </ReviewSplitButtonContent>
      ) : (
        'Review split'
      ),
      isDisabled: isReviewingSplit,
      onClick: onReviewSplit,
      trackingId:
        SAMPLING_CAMPAIGNS_TRACKING_ID.CAMPAIGN_REQUEST_PRODUCTS_REWORK_SPLIT_UPDATE_MODAL_REVIEW_BUTTON,
    }}
    secondaryButtonInfo={{
      buttonContent: 'Review later',
      isDisabled: isReviewingSplit,
      onClick: onClose,
      trackingId:
        SAMPLING_CAMPAIGNS_TRACKING_ID.CAMPAIGN_REQUEST_PRODUCTS_REWORK_SPLIT_UPDATE_MODAL_LATER_BUTTON,
    }}
    shouldCloseOnClickOutside={false}
    shouldCloseOnEsc={!isReviewingSplit}
    title='Review Instagram and Tiktok Split'
    width='wide'
  />
);

const ReviewSplitButtonContent = styled.div`
  align-items: center;
  display: flex;
`;
